<div class="btn-group" dropdown placement="left" #dropdown="bs-dropdown">
    <div class="pointer" dropdownToggle>
        <button class="btn btn-icon btn-lg">
            <div class="notification-bell">
                <div class="notification-badge notification-badge-all" [hidden]="!unreadNotificationsCount">
                    {{ unreadNotificationsCount }}
                </div>
                <sb-inline-svg class="icon" [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Bell icon.svg'">
                </sb-inline-svg>
            </div>
        </button>
    </div>

    <div *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="button-menu-dividers">
        <div class="notification-buttons" (click)="$event.stopPropagation()">
            <label class="switch-label mb-0 me-3">
                <ui-switch [(ngModel)]="isShowUnread" (valueChange)="isShowUnread = $event"></ui-switch>
                <span translate>Show only unread</span>
            </label>
            <a
                class="btn btn-icon"
                [routerLink]="['/', commonDataService.communityName, 'notifications']"
                target="_blank"
                [tooltip]="'In new window' | translate"
                container="body"
                placement="bottom">
                <sb-inline-svg
                    class="icon external-link-icon"
                    aria-label="In new window"
                    [url]="'/sb-tools/theme/images/icons/external-link-icon.svg'">
                </sb-inline-svg>
            </a>
        </div>

        <div class="notification-bar" (click)="$event.stopPropagation()">
            <tabset>
                <tab
                    [ngClass]="{ active: notificationGroup === notificationGroupTypeEnum.activity }"
                    (selectTab)="notificationGroup = notificationGroupTypeEnum.activity">
                    <ng-template tabHeading>
                        <div class="tab-wrapper">
                            <span class="tab-title" translate>Activity</span>
                            <ng-container
                                *ngTemplateOutlet="
                                    badge;
                                    context: { groupKey: notificationGroupTypeEnum.activity }
                                "></ng-container>
                        </div>
                    </ng-template>

                    @if (notificationGroup === notificationGroupTypeEnum.activity) {
                        <ng-container *ngTemplateOutlet="notificationsContent"></ng-container>
                    }
                </tab>
                <tab
                    [ngClass]="{ active: notificationGroup === notificationGroupTypeEnum.notes }"
                    (selectTab)="notificationGroup = notificationGroupTypeEnum.notes">
                    <ng-template tabHeading>
                        <div class="tab-wrapper">
                            <span class="tab-title" translate>Notes</span>
                            <ng-container
                                *ngTemplateOutlet="
                                    badge;
                                    context: { groupKey: notificationGroupTypeEnum.notes }
                                "></ng-container>
                        </div>
                    </ng-template>

                    @if (notificationGroup === notificationGroupTypeEnum.notes) {
                        <ng-container *ngTemplateOutlet="notificationsContent"></ng-container>
                    }
                </tab>
                <tab
                    [ngClass]="{ active: notificationGroup === notificationGroupTypeEnum.soMe }"
                    (selectTab)="notificationGroup = notificationGroupTypeEnum.soMe">
                    <ng-template tabHeading>
                        <div class="tab-wrapper">
                            <span class="tab-title" translate>SoMe tickets</span>
                            <ng-container
                                *ngTemplateOutlet="
                                    badge;
                                    context: { groupKey: notificationGroupTypeEnum.soMe }
                                "></ng-container>
                        </div>
                    </ng-template>
                    @if (notificationGroup === notificationGroupTypeEnum.soMe) {
                        <ng-container *ngTemplateOutlet="notificationsContent"></ng-container>
                    }
                </tab>
            </tabset>
            <a class="mark-all-as-read-link" (click)="notificationListComponent.markAllAsRead()" translate
                >Mark all as read</a
            >
        </div>

        <ng-template #notificationsContent>
            @if (dropdown.isOpen) {
                <div class="notifications-scrolled-container" #scrolledContainer>
                    <app-notification-list
                        [infiniteScrollContainerClass]="'.notifications-scrolled-container'"
                        [notificationGroup]="notificationGroup"
                        [isShowUnread]="isShowUnread"
                        (needToCloseDropdownEvent)="dropdown.hide()">
                    </app-notification-list>
                </div>
            }
        </ng-template>

        <ng-template #badge let-groupKey="groupKey">
            @if (unreadNotificationsCounts[groupKey]() > 0) {
                <div class="badge tab-badge">
                    {{ unreadNotificationsCounts[groupKey]() }}
                </div>
            }
        </ng-template>
    </div>
</div>
